export default __webpack_public_path__ + "static/media/MarsCentra-Extrabold.856f81ef.woff";